import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const updateFacilityGroupMutationAtom = createMutationAtomFactory(
  'settings.facilityGroupUpdate',
  (params: {
    id: string;
    name?: string;
    facilityIds?: string[];
    defaultFacilityId?: string | null;
    customAttributes?: Record<string, unknown>;
  }) => ({
    coreFacilityGroupUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          facilityIds: params.facilityIds,
          defaultFacilityId: params.defaultFacilityId,
          customAttributes: params.customAttributes,
        },
      },
      id: true,
      name: true,
    },
  }),
);
